"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.customErrMsgs = void 0;
exports.getVideoCallErrorMessage = getVideoCallErrorMessage;
require("antd/lib/typography/style");
var _typography = _interopRequireDefault(require("antd/lib/typography"));
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
var _utils = require("../../../utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Paragraph = _typography.default.Paragraph,
  Text = _typography.default.Text;
var ua = (0, _utils.userAgent)();
var mediaAccessDeniedLinks = [{
  browser: 'Safari',
  href: 'https://support.apple.com/en-gb/guide/safari/ibrwe2159f50/mac',
  label: 'Safari'
}, {
  browser: 'Chrome',
  href: 'https://support.google.com/chrome/answer/2693767?co=GENIE.Platform%3DDesktop&hl=en',
  label: 'Chrome'
}, {
  browser: 'Microsoft Edge',
  href: 'https://support.microsoft.com/en-gb/help/4468232/windows-10-camera-microphone-and-privacy',
  label: 'Edge'
}, {
  browser: 'Firefox',
  href: 'https://support.mozilla.org/en-US/kb/how-manage-your-camera-and-microphone-permissions',
  label: 'Mozilla Firefox'
}];
var cameraNotAvailableLinks = [{
  href: 'https://support.apple.com/en-us/HT211130',
  label: 'Mac OS',
  os: 'macOS'
}, {
  href: 'https://support.apple.com/en-us/HT203040',
  label: 'iOS',
  os: 'iOS'
}, {
  href: 'https://support.microsoft.com/en-us/help/13753/windows-10-camera-does-not-work',
  label: 'Windows',
  os: 'Windows'
}, {
  href: 'https://support.google.com/android/search?q=Camera%20Not%20Working',
  label: 'Android',
  os: 'Android'
}];
var PLEASE_CONTACT_US = /*#__PURE__*/_react.default.createElement(Paragraph, null, "If you are still having issues please contact us at:", ' ', /*#__PURE__*/_react.default.createElement("a", {
  href: _utils.SUPPORT_URL,
  rel: "noopener noreferrer",
  target: "_blank",
  className: "medium"
}, "support@joinmonument.com"));
var Link = function Link(_ref) {
  var href = _ref.href,
    label = _ref.label;
  return /*#__PURE__*/_react.default.createElement(Paragraph, null, "- ", /*#__PURE__*/_react.default.createElement(LinkInline, {
    href: href,
    label: label
  }));
};
var LinkInline = function LinkInline(_ref2) {
  var href = _ref2.href,
    label = _ref2.label;
  return /*#__PURE__*/_react.default.createElement("a", {
    rel: "noopener noreferrer",
    target: "_blank",
    href: href,
    className: "medium"
  }, /*#__PURE__*/_react.default.createElement(Text, {
    underline: true
  }, label));
};
var customErrMsgs = [{
  code: 'CUSTOM_OT_CAMERA_NOT_AVAILABLE',
  description: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Paragraph, {
    className: "medium"
  }, "For instructions how to fix it select a link below:"), cameraNotAvailableLinks.filter(function (link) {
    return link.os === ua.os;
  }).map(function (_ref3) {
    var href = _ref3.href,
      label = _ref3.label;
    return /*#__PURE__*/_react.default.createElement(Link, {
      href: href,
      label: label,
      key: label
    });
  }), PLEASE_CONTACT_US),
  message: 'Camera is not recognized, cannot publish video.'
}];
exports.customErrMsgs = customErrMsgs;
var concatDevices = function concatDevices(devices) {
  return (devices === null || devices === void 0 ? void 0 : devices.length) > 0 ? (0, _lodash.compact)([!devices.audio && 'microphone', !devices.video && 'camera']).join(' and ') : 'devices';
};
var otErrMsgs = [{
  code: 'OT_MEDIA_ERR_ABORTED',
  notification: {
    description: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Paragraph, {
      className: "medium"
    }, "Please check your browser updates, reboot your device and try again."), PLEASE_CONTACT_US),
    message: 'We are unable to connect to either your camera or microphone'
  }
}, {
  code: 'OT_HARDWARE_UNAVAILABLE',
  notification: function notification() {
    var devices = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var problemDevices = concatDevices(devices);
    return {
      description: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Paragraph, {
        className: "medium"
      }, "Please close any other applications which may be using your ", problemDevices, " and reload this page."), PLEASE_CONTACT_US),
      message: "We could not connect to your ".concat(problemDevices, ".")
    };
  }
}, {
  code: 'OT_USER_MEDIA_ACCESS_DENIED',
  notification: function notification() {
    var devices = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var problemDevices = concatDevices(devices);
    return {
      description: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Paragraph, {
        className: "medium"
      }, "Here are instructions for how to enable access to your ", problemDevices, " for your browser:"), mediaAccessDeniedLinks.filter(function (link) {
        return ua.name === link.browser;
      }).map(function (_ref4) {
        var href = _ref4.href,
          label = _ref4.label;
        return /*#__PURE__*/_react.default.createElement(Link, {
          href: href,
          label: label,
          key: label
        });
      }), PLEASE_CONTACT_US),
      message: "Please enable access to your ".concat(problemDevices)
    };
  }
}, {
  code: 'OT_NO_DEVICES_FOUND',
  notification: {
    description: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Paragraph, {
      className: "medium"
    }, "Please check that your camera and microphone are connected and try again."), PLEASE_CONTACT_US),
    message: 'We are unable to connect to either your camera or microphone'
  }
}, {
  code: 'OT_NOT_SUPPORTED',
  notification: {
    description: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Paragraph, {
      className: "medium"
    }, (0, _utils.chromeOnIOS)() ? 'On iOS devices video calls only work in Safari. Please try again using Safari.' : 'Your browser does not support video calls. Please try to upgrade your browser or use another one.'), ' ', ":", PLEASE_CONTACT_US),
    message: 'Please use a different browser'
  }
}, {
  code: 'OT_TIMEOUT',
  notification: {
    description: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Paragraph, {
      className: "medium"
    }, "We were unable to connect you to the video chat. Please check", ' ', /*#__PURE__*/_react.default.createElement(LinkInline, {
      href: "https://support.tokbox.com/hc/en-us/articles/360029733631-What-are-the-TokBox-network-connectivity-requirements-",
      label: "connectivity requirements"
    }), "."), /*#__PURE__*/_react.default.createElement(Paragraph, null, "You can also try a", ' ', /*#__PURE__*/_react.default.createElement(LinkInline, {
      href: "https://tokbox.com/developer/tools/precall/",
      label: "Pre-call Test"
    }), ' ', "to test your connectivity."), PLEASE_CONTACT_US),
    message: 'Error connecting to video session'
  }
}, {
  code: 'OT_CHROME_MICROPHONE_ACQUISITION_ERROR',
  notification: {
    description: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Paragraph, {
      className: "medium"
    }, "Please exit and reopen Chrome and reload this page."), /*#__PURE__*/_react.default.createElement("br", null), PLEASE_CONTACT_US),
    message: 'We are unable to access your microphone'
  }
}, {
  code: 'DEFAULT',
  notification: {
    description: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Paragraph, {
      className: "medium"
    }, "We were unable to connect you to the video chat. Please check", ' ', /*#__PURE__*/_react.default.createElement(LinkInline, {
      href: "https://support.tokbox.com/hc/en-us/articles/360029733631-What-are-the-TokBox-network-connectivity-requirements-",
      label: "connectivity requirements"
    }), "."), /*#__PURE__*/_react.default.createElement(Paragraph, null, "You can also try a", ' ', /*#__PURE__*/_react.default.createElement(LinkInline, {
      href: "https://tokbox.com/developer/tools/precall/",
      label: "Pre-call Test"
    }), ' ', "to test your connectivity."), /*#__PURE__*/_react.default.createElement("br", null), PLEASE_CONTACT_US),
    message: 'Something went wrong!'
  }
}, {
  code: 'OT_STREAM_DESTROYED',
  notification: null
}];
function getVideoCallErrorMessage(error, devices) {
  var _otErrMsgs$find;
  var customMsg = (error === null || error === void 0 ? void 0 : error.name) && ((_otErrMsgs$find = otErrMsgs.find(function (err) {
    return err.code === error.name;
  })) === null || _otErrMsgs$find === void 0 ? void 0 : _otErrMsgs$find.notification);
  if (customMsg === null) {
    return null;
  }
  if ((0, _lodash.isFunction)(customMsg)) {
    customMsg = customMsg(devices);
  }
  return customMsg || typeof (error === null || error === void 0 ? void 0 : error.message) === 'string' && {
    message: error === null || error === void 0 ? void 0 : error.message
  } || otErrMsgs.find(function (err) {
    return err.code === 'DEFAULT';
  });
}